export default "__VITE_ASSET__CwmsQPWX__"